import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import { getAllStrengthTrainers } from '../data/trainers/StrengthTrainers';
import './StrengthTrainers.css';

const StrengthTrainers = () => {
    const navigate = useNavigate();

    // Get strength trainers from the trainers data file
    const strengthTrainersData = getAllStrengthTrainers();

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('Strength trainer selected:', trainer);

        // 🎵 PLAY CORRECT STRENGTH TRAINER SELECTION SOUND
        soundManager.playSound('strengthSet2', 0.7);

        // Navigate to the strength trainer page
        navigate(`/strength-trainer/${trainer.id}`);
    };

    // Handle back to train categories
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/train-categories');
    };

    return (
        <div className="strength-trainers-container">
            {/* Red pulsating background */}
            <div className="red-pulsing-background"></div>

            <header className="strength-trainers-header">
                <button
                    className="back-to-categories-button"
                    onClick={handleBackToCategories}
                >
                    ← Back to Categories
                </button>

                <div className="header-content">
                    <h1>Pick Your Strength Trainer</h1>
                    <p>Powerful coaches for maximum strength development</p>
                    <div className="category-stats">
                        <span className="stat-badge">6 Power Coaches</span>
                        <span className="stat-badge">36 Strength Programs</span>
                        <span className="stat-badge">Maximum Gains</span>
                    </div>
                </div>
            </header>

            <div className="strength-trainers-grid">
                {strengthTrainersData.map((trainer) => (
                    <div
                        key={trainer.id}
                        className="strength-trainer-card"
                        onClick={() => handleTrainerSelect(trainer)}
                    >
                        <div className="strength-trainer-image-section">
                            <div
                                className="strength-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center'
                                }}
                            >
                                <div className="experience-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        <div className="strength-trainer-info-section">
                            <h3 className="strength-trainer-name">{trainer.name}</h3>
                            <h4 className="strength-trainer-specialization">{trainer.specialization}</h4>
                            <p className="strength-trainer-description">{trainer.intro?.substring(0, 120)}...</p>

                            <div className="strength-trainer-details">
                                <div className="detail-item">
                                    <span className="detail-icon">💪</span>
                                    <span className="detail-text">{trainer.category} specialist</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-icon">📋</span>
                                    <span className="detail-text">{trainer.programs?.length || 6} Programs</span>
                                </div>
                            </div>

                            <div className="strength-trainer-action">
                                <button className="select-strength-trainer-button">
                                    Power Programs
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <footer className="strength-trainers-footer">
                <div className="strength-info">
                    <h3>💪 Maximum Strength Development</h3>
                    <div className="strength-benefits-grid">
                        <div className="strength-benefit-item">
                            <span className="benefit-icon">🏋️‍♂️</span>
                            <div>
                                <strong>Raw Power</strong>
                                <p>Build explosive strength and maximum muscle mass</p>
                            </div>
                        </div>
                        <div className="strength-benefit-item">
                            <span className="benefit-icon">⚡</span>
                            <div>
                                <strong>Progressive Loading</strong>
                                <p>Systematic progression for continuous strength gains</p>
                            </div>
                        </div>
                        <div className="strength-benefit-item">
                            <span className="benefit-icon">🎯</span>
                            <div>
                                <strong>Elite Performance</strong>
                                <p>Train like the strongest athletes in the world</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default StrengthTrainers;